import React, { useState } from "react";
import { t } from '../../i18n';
import queries from "../../queries";
import { Mutation, Query } from "react-apollo";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { FormattedMessage } from "react-intl";
import "../../style/DisplayManagement.scss";

export default function DisplayGroupsList() {

  const [groupName, setGroupName] = useState("");

  return (
    <Mutation
      mutation={queries.displays.createDevicesGroup}
      refetchQueries={[{ query: queries.displays.listGroup }]}
    >
      {(createDevicesGroup) => (
        <div className="tsk-display-groups-page">
          <div className="tsk-display-groups-create">
            <div className="tsk-display-groups-create__title">
              <FormattedMessage id="display.create.group.section" defaultMessage="Nouveau groupe d'écrans" />
            </div>
            <div className="tsk-display-groups-create__row">
              <input
                type="text"
                maxLength={255}
                minLength={3}
                className="tsk-input-lines"
                value={groupName}
                onChange={(e) => { setGroupName(e.target.value); }}
                placeholder=""
              />
              <button
                type="button"
                className="tsk-btn-update"
                onClick={() => { createDevicesGroup({ variables: { name: groupName } }); }}
              >
                <FormattedMessage id="display.create.group" />
              </button>
            </div>
          </div>

          <Query query={queries.displays.listGroup}>
            {({ loading, error, data }) => {
              if (loading) return <div className="tsk-display-management--loading">{t('ui.common.loading')}</div>;
              if (error) return `Error! ${error.message}`;

              if (data.devicesGroups.length === 0) {
                return null;
              }

              return (
                <ul className="tsk-display-groups-list">
                  <li className="tsk-display-groups-list__item">
                    <Link className="tsk-display-groups-list__link" to="/admin/displaysGroup/all">
                      All
                    </Link>
                  </li>
                  <li className="tsk-display-groups-list__item">
                    <Link className="tsk-display-groups-list__link" to="/admin/displaysGroup/bureau">
                      Bureau
                    </Link>
                  </li>
                  <li className="tsk-display-groups-list__item">
                    <Link className="tsk-display-groups-list__link" to="/admin/displaysGroup/noname">
                      No name
                    </Link>
                  </li>
                  {data.devicesGroups.map((group) => (
                    <li key={group.id} className="tsk-display-groups-list__item">
                      <Link className="tsk-display-groups-list__link" to={`/admin/displaysGroup/${group.id}`}>
                        {group.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              );
            }}
          </Query>
        </div>
      )}
    </Mutation>
  );
}
